import React from 'react';
import '../../components/css/popupstyle.css';
import editIcon from '../.././components/css/dark/img/theme-images/edit.svg';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import { userService } from '../../_services';
import DeleteIcon from '../.././components/css/dark/img/delete.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';

class ManageGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            userdata: JSON.parse(localStorage.getItem('user')),
            activePage: 1,
            UserList: [],
            UserList_Temp: [],
            mainAPIresult: [],
            UserChainList: [],
            ChainNamesList: [],
            UserChainNamesList: [],
            noInitialChainList: true,
            error: '',
            editable: false,
            groupActivePagin: 1,
            activeState: false,
            Data_Not_Found: '',
            selectedGroups: [],
            searchQuery: "",
            initialCommission: "",
            filteredList: [],
        }
        this.add_NewChain_row = this.add_NewChain_row.bind(this);
    }
    componentDidMount() {
        this.fetchDataLocally('Admin', 'Admin', this.props.whId);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        this.fetchPharmacyChainList();
        this.fetchUserPharmacyChainList(this.props.whName, this.props.whId);
    }
    fetchDataLocally(roleName, roleType, id) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, id })
            };
            return fetch(`/api/admin/GetGroupList`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: apidata, loader: false });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    fetchPharmacyChainList() {
        try {
            userService.fetchPharmacyChainList('a', 'a')
                .then(response => this.handleResponse(response))
                .then(data => {
                    this.setState({ loader: false, ChainNamesList: data, btnLoader: false });
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                    this.setState({ loader: false, error: 'Oops! Something went wrong. Try Again.', btnLoader: false });

                    setTimeout(() => {
                        this.setState({ error: '', successMsg: '' })
                    }, 3000)
                });
        } catch (error) {
            this.setState({ loader: false, error: 'Oops! Something went wrong. Try Again.', btnLoader: false });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    fetchUserPharmacyChainList(whname, wholesaler_Id) {
        try {
            userService.fetchUserPharmacyChainList(whname, wholesaler_Id, 0)
                .then(response => this.handleResponse(response))
                .then(data => {
                    if (data[0].chainNames.length) {
                        const groupNumbers = data[0].groupNumbers && data[0].groupNumbers.length ? data[0].groupNumbers.map((gn) => { return gn.groupNumber }) : []
                        this.setState({ UserChainNamesList: data[0].chainNames, noInitialChainList: data && data[0].chainNames && data[0].chainNames.length && data[0].isGroupSpecific ? false : true, initialCommission: data[0].whCommission, selectedGroups: groupNumbers });
                    } else {
                        this.setState({ UserChainNamesList: [{ chainName: 'General', commission: data[0].whCommission }], noInitialChainList: data && data[0].chainNames && data[0].chainNames.length && data[0].isGroupSpecific ? false : true, initialCommission: data[0].whCommission });
                    }
                })
                .catch(error => {
                    this.setState({ error: 'Oops! Something went wrong. Try Again.' });
                    setTimeout(() => {
                        this.setState({ error: '', successMsg: '' })
                    }, 3000)
                });
        }
        catch (error) {
            this.setState({ loader: false, btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    handleSearchChange = (event) => {
        const inputValue = event.target.value.trim();
        this.setState({ searchQuery: inputValue });

        if (inputValue) {
            // Filter only matching group numbers
            const filtered = this.state.UserList_Temp.filter((item) =>
                item.groupNumber.toLowerCase().includes(inputValue.toLowerCase())
            );
            this.setState({ filteredList: filtered });
        } else {
            this.setState({ filteredList: [] }); // Hide dropdown if input is empty
        }
    };


    handleBack = () => {
        /*if (this.props.onClose) {
            this.props.onClose(); // Calls the parent’s function to close popup
        }*/
        this.props.closemanageGroupSection(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        this.props.openAddOverridePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
    };
    handleSelectChange = (event) => {
        const selectedValue = event.target.value.trim(); // Trim any extra spaces

        // Ensure selectedValue is not empty and is unique
        const isValid = this.state.UserList_Temp.some(obj => obj.groupNumber === selectedValue)
        if (selectedValue && !this.state.selectedGroups.includes(selectedValue) && isValid) {
            this.setState((prevState) => ({
                selectedGroups: [...prevState.selectedGroups, selectedValue]
            }));
        }
    };

    handleSelectItem = (selectedValue) => {
        if (selectedValue && !this.state.selectedGroups.includes(selectedValue)) {
            this.setState((prevState) => ({
                selectedGroups: [...prevState.selectedGroups, selectedValue],
                searchQuery: "", // Clear input after selection
                filteredList: [] // Hide the dropdown after selection
            }));
        }
    };
    add_NewChain_row(event) {
        try {
            const chainData = [...this.state.UserChainNamesList]
            if (this.state.UserChainNamesList != null && this.state.UserChainNamesList.length > 0) {
                const prevRow = chainData[chainData.length - 1]
                const hasChainName = !userService.Check_Null_Empty(prevRow.chainName);
                const hasComm = !userService.Check_Null_Empty(prevRow.comm);
                if (hasChainName && hasComm) {
                    prevRow.editable = false
                    let rowdata = { chainName: '', comm: "", editable: true };
                    chainData.forEach((row, index) => {
                        row.editable = false;
                    });
                    this.setState({ UserChainNamesList: [...chainData, rowdata], error: '' });
                } else {
                    this.setState({ error: 'Please fill or save previous fields first' });
                }
            }
            else {
                const chainData = [];
                let rowdata = { chainName: '', comm: "", editable: true };
                chainData.forEach((row, index) => {
                    row.editable = false;
                });
                this.setState({ UserChainNamesList: [...chainData, rowdata], error: '' });
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    showList = (e) => {
        try {
            e.target.nextElementSibling.classList.add('open');
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    hideList = (e) => {
        try {
            setTimeout(() => {
                $('.first-one ul').removeClass('open');
            }, 500);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    keyPress = (e) => {
        try {
            const inputValue = e.target.value.toLowerCase();
            const ulElement = e.target.nextElementSibling; // Ensure it's the <ul>

            if (ulElement && ulElement.tagName === "UL") {
                const liElements = ulElement.querySelectorAll("li");

                if (inputValue.length > 0) {
                    ulElement.classList.add("open");

                    this.state.ChainNamesList.forEach((item, i) => {
                        if (item.chainName.toLowerCase().includes(inputValue)) {
                            liElements[i].style.display = "block";
                        } else {
                            liElements[i].style.display = "none";
                        }
                    });
                } else {
                    ulElement.classList.remove("open");
                    liElements.forEach(li => (li.style.display = "block")); // Show all if input is empty
                }
            }
        } catch (error) {
            this.setState({ error: "Error, Try again" });
        }
    };
    handleChange_chain_user(e) {
        try {
            //let overrideData = this.state.overrides;
            let chainListName = $(e.target).attr('chName');
            //let rowIndex = $(e.target).attr('chIndex');

            e.target.parentElement.parentElement.children[0].value = chainListName;
            $(e.target).parents().removeClass('open');

            //e.target.parentElement.nextSibling.textContent = chainListName;
            //overrideData[rowIndex].chainName = chainListName;
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleChange_chain_commission(e) {
        try {
            //let overrideData = this.state.overrides;
            let chainListCommission = e.target.value;
            //let rowIndex = $(e.target).attr('chIndex');
            e.target.parentElement.parentElement.children[0].children[0].value = chainListCommission;
            //e.target.nextSibling.textContent = chainListCommission;
            //overrideData[rowIndex].comm = chainListCommission;
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleEdit = (e) => {
        try {
            let chainData = [...this.state.UserChainNamesList];
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let currentRowIndex = e.target.closest('tr').getAttribute('dataIndex');
            chainData.forEach((row, index) => {
                if (index !== parseInt(currentRowIndex)) {
                    row.editable = false;
                }
            });

            // Make current row editable
            name = chainData[currentRowIndex].chainName;
            commission = chainData[currentRowIndex].comm;
            chainData[currentRowIndex].editable = true;

            this.setState({ UserChainNamesList: chainData });
            //e.target.parentElement.parentElement.classList.add("ineditable");
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    handlecancel = (e) => {
        try {
            this.setState({ error: '', btnLoader: false, loader: false });
            let chainData = [...this.state.UserChainNamesList];
            let rowIndex = e.target.closest('tr').getAttribute('dataIndex');
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let rowData = chainData[rowIndex];
            if (!rowData) return
            const hasChainName = !userService.Check_Null_Empty(name);
            const hasOverrideChainName = !userService.Check_Null_Empty(rowData.chainName);
            const hasComm = !userService.Check_Null_Empty(commission);
            const hasOverrideComm = !userService.Check_Null_Empty(rowData.comm);

            if (!hasChainName && !hasComm && !hasOverrideChainName && !hasOverrideComm) {
                chainData.splice(rowIndex, 1);
            } else if (hasChainName && hasComm && hasOverrideChainName && hasOverrideComm) {
                name = rowData.chainName;
                commission = rowData.comm;
                rowData.editable = false;
            } else {
                rowData.editable = false;
            }

            this.setState({ UserChainNamesList: chainData });
        }
        catch (error) {
            this.setState({ error: 'Error, Try again', btnLoader: false });
        }
    }
    saveData = (e) => {
        try {
            // get input field values
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let currentIndex = e.target.parentElement.parentElement.getAttribute("dataIndex");
            if (!userService.Check_Null_Empty(name) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
                if (commission > 10) {
                    this.setState({ error: 'Commission should not be more than 10', loader: false, btnLoader: false });
                } else if (commission <= 0) {
                    this.setState({ error: 'Commission should be more than 0', loader: false, btnLoader: false });
                } else {
                    e.target.parentElement.parentElement.classList.remove("ineditable");
                    let chainData = this.state.UserChainNamesList;
                    chainData.splice(currentIndex, 1, { chainName: name, comm: commission, editable: false });
                    this.setState({ error: '', overrides: chainData });
                }
            } else {
                this.setState({ error: "Fields can't be blank and commission should be a numeric value e.g. 0.10" });
            }
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    handleRemoveGroup = (group) => {
        this.setState(prevState => ({
            selectedGroups: prevState.selectedGroups.filter(item => item !== group)
        }));
    }
    handleSaveSubmit = (e) => {
        this.setState({ btnLoader: true, loader: true });
        try {
            const isEditMode = this.state.UserChainNamesList.some(row => row.editable === true);
            if (isEditMode) {
                this.setState({ error: 'Please save all the fields first', btnLoader: false, loader: false });
                setTimeout(() => {
                    this.setState({ error: '', successMsg: '' })
                }, 3000)
                return false;
            } else if (this.state.selectedGroups.length === 0) {
                this.setState({ error: 'Please select group number(s)', btnLoader: false, loader: false });
                setTimeout(() => {
                    this.setState({ error: '', successMsg: '' })
                }, 3000)
                return false;
            } else {
                let chainData = [...this.state.UserChainNamesList].map((item) => ({ ChainName: item.chainName, Comm: item.comm }));
                if (chainData.length > 0) {
                    this.saveChainList(chainData);
                }
                else {
                    this.setState({ error: 'Please add pharmacy chain list', btnLoader: false, loader: false });
                    setTimeout(() => {
                        this.setState({ error: '', successMsg: '' })
                    }, 3000)
                    return false;
                }
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again', btnLoader: false, loader: false });
        }
    }
    saveChainList(chainData) {
        $(".button-section .save").attr("disabled", "true");
        try {
            const flag = this.state.noInitialChainList ? 0 : 1
            userService.add_update_PharmacyChainList_gs(chainData, this.props.whName, this.props.whId, flag, this.state.selectedGroups.join(','), true)
                .then(data => {
                    if (data.length > 0) {
                        if (data[0].status_code == "1") {
                            this.setState({ loader: false, btnLoader: false, successMsg: data[0].status_message });
                            $(".button-section .save").removeAttr("disabled");
                            this.fetchUserPharmacyChainList(this.props.whName, this.props.whId)
                            setTimeout(() => {
                                this.setState({ successMsg: '' })
                            }, 3000)
                        }
                        else {
                            this.setState({ loader: false, btnLoader: false, error: data[0].status_message });
                            setTimeout(() => {
                                this.setState({ successMsg: '', error: '' })
                            }, 3000)
                            $(".button-section .save").removeAttr("disabled");
                            //this.fetchUserPharmacyChainList(this.props.whName, this.props.whId)
                        }
                    }
                    else {
                        $(".button-section .save").removeAttr("disabled");
                        this.setState({ loader: false, btnLoader: false, error: 'Oops! Something went wrong. Try Again.' });
                        setTimeout(() => {
                            this.setState({ error: '' })
                        }, 3000)
                    }
                })
                .catch(error => {
                    $(".button-section .save").removeAttr("disabled");
                    this.setState({ loader: false, btnLoader: false, error: 'Oops! Something went wrong. Try Again.' });
                    setTimeout(() => {
                        this.setState({ error: '' })
                    }, 3000)
                });
        }
        catch (error) {
            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.', btnLoader: false });
            $(".button-section .save").removeAttr("disabled");
            setTimeout(() => {
                this.setState({ error: '' })
            }, 3000)
        }
    }
    handleClose = () => {
        try {
            this.props.closemanageGroupSection(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
            this.props.openAddOverridePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    cancelList = (e, index) => {
        try {
            const chainData = this.state.UserChainNamesList
            chainData.splice(index, 1)
            this.setState({ UserChainNamesList: chainData })
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    render() {
        const { loader, ChainNamesList, UserChainNamesList, btnLoader, successMsg } = this.state;
        const { error } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;

        return (
            <div className='popup mfp-zoom-in override-content admin-popup whOverride-popup chainList-popup'>
                <div className='popup_inner  manage-distributor-design manage-chain-list-group-admin'>
                    <h1>{this.props.text}<button onClick={this.handleBack}>X</button></h1>
                    {
                        this.state.loader ? (<div className="theme-loader group-list"></div>) : null
                    }
                    <div className="group-selection-wrapper">
                        <div className="searchSection populate">
                            <label>Search Group Numbers</label>
                            <div className="autocomplete">
                                <input disabled={disabled} id="btn_SearchGroupNumber" type="text" name="GroupNumberInput" scroll-id="CITY" data-id="dynamic" placeholder="Search" onKeyUp={this.handleSearchChange} className="form-control searchTable searchtextarea" autoComplete="off" />
                                {this.state.filteredList.length > 0 && (
                                    <ul className="suggestions" style={{ height: '50px', display: 'block' }}>
                                        {this.state.filteredList.map((item, index) => (
                                            <li key={index} onClick={() => this.handleSelectItem(item.groupNumber)}>
                                                {item.groupNumber}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="new-column gap-left select-section">
                            <div className="same-on">
                                <label>Select Group Numbers</label>
                                <span class="down-arrow"></span>
                                <select className="form-control" onChange={this.handleSelectChange}>
                                    <option>Select Group Number</option>
                                    {
                                        this.state.UserList_Temp.map((e1, index) => {
                                            return <option>{e1.groupNumber}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="selected-items">
                            {
                                this.state.selectedGroups.length > 0 ?
                                    <div className="selected-filters">
                                        <label>Selected Group Numbers:</label>
                                        <div className="selectFilter">
                                            {this.state.selectedGroups.map((item, index) => <div className="selected-filter-name" key={index}>
                                                <span className="close" onClick={() => this.handleRemoveGroup(item)}></span>
                                                <span className="group-name">{item}</span>
                                            </div>)}
                                        </div>
                                    </div> : null
                            }
                        </div>
                    </div>
                    <div className="wholesaler-section">
                        <form className="add-wh-form">
                            <div className="login-hub-section">

                                <div className="override-section milestone differ">
                                    <div className="right">
                                        <h2 className="adding-override">Chain List</h2>
                                        <React.Fragment>
                                            <button id="lastChance" className="add-new" type="button" onClick={disabled ? null : this.add_NewChain_row} style={{ fontWeight: '400' }}>Add New Chain</button>
                                            {
                                                UserChainNamesList != null && UserChainNamesList.length > 0 ?
                                                    <table className="override-added">
                                                        <thead>
                                                            <tr className="header Sub">
                                                                <th className="first-one">Name</th>
                                                                <th className="third-one">Commission</th>
                                                                <th className="fourth-one">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                UserChainNamesList.map((grouprow, index) =>
                                                                    <tr className={grouprow.editable ? "milestoneData ineditable" : "milestoneData"} dataIndex={index}>
                                                                        <td className="first-one">
                                                                            <div className="formgroup" key={grouprow.id}>
                                                                                <input type="text" defaultValue={grouprow.chainName} autoComplete={'off'} onFocus={this.showList} onBlur={this.hideList} className="namefield_ form-control" name="overrides_name" onKeyUp={this.keyPress} readOnly={grouprow.chainName === 'General'} style={{ pointerEvents: grouprow.chainName === 'General' ? 'none' : '' }} />
                                                                                <ul>
                                                                                    {ChainNamesList.map((item, index) => <li key={index} onClick={this.handleChange_chain_user.bind(this)} chName={item.chainName} chComm={item.commission} chIndex={index}>{item.chainName}</li>)}
                                                                                </ul>
                                                                                <span>{grouprow.chainName}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="third-one">
                                                                            <div className="formgroup">
                                                                                <input onKeyUp={this.validateCommission} defaultValue={grouprow.comm} onChange={this.handleChange_chain_commission} type="text" chIndex={index} className="form-control" name="commission" autoComplete="off" />
                                                                                <span>{grouprow.comm ? grouprow.comm : '0'}</span>
                                                                                <input type="text" className="form-control defaultInput" defaultValue={grouprow.comm} name="Id" />
                                                                            </div>
                                                                        </td>
                                                                        <td className="fourth-one">
                                                                            <input type="button" className="btn save" onClick={this.saveData} value="Save" />
                                                                            <input type="button" onClick={this.handlecancel} className="btn cancel" value="Cancel" />
                                                                            <img src={EditIcon} onClick={this.handleEdit} className="editIcon" alt="editIcon" style={{ cursor: 'pointer' }} />
                                                                            {grouprow.chainName !== 'General' ? <img src={DeleteIcon} onClick={(e) => this.cancelList(e, index)} className="deleteIcon" alt="deleteIcon" style={{ cursor: 'pointer' }} /> : null}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                        </tbody>
                                                    </table>
                                                    : <span className="no-override-added">No pharmacy chain added yet</span>
                                            }
                                        </React.Fragment>
                                    </div>
                                </div>

                                <div className="button-section override-btn-section">
                                    {btnLoader &&
                                        <div className="theme-loader animated-loader" style={{ top: '-24px' }}></div>
                                    }
                                    <input disabled={disabled} type="button" onClick={this.handleSaveSubmit} className={btnLoader ? 'btn save animated-btn' : 'btn save'} value="Save & Submit" />
                                    <input disabled={disabled} type="button" onClick={this.handleClose} className="btn cancel" value="Cancel" />
                                    {(error || this.state.error) &&
                                        <div className={'error'}>{error || this.state.error}</div>
                                    }
                                    {(successMsg) &&
                                        <div className={'success'}>{successMsg}</div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default ManageGroup;